import {IActionModel} from "../../shared/models/action.model";
import {SET_FORM_STATE_CHANGES_DATA} from "../actions/form-state.action";

export interface IFormStateReducerState {
    isFormChanges: boolean,
}


const initialData: IFormStateReducerState = {
    isFormChanges: false,
};

const FormStateReducer = (state = initialData, action: IActionModel): IFormStateReducerState => {
    // console.log(action?.payload?.isFormChanges);
    switch (action.type) {
        case SET_FORM_STATE_CHANGES_DATA:
            state = {
                ...state,
                isFormChanges: action.payload.isFormChanges
            };
            return state;
        default:
            return state;
    }
};

export default FormStateReducer;
